export default __webpack_public_path__ + "static/media/7C1_E-2724.0dff4959.png";